import EnquiriesManagement from '../EnquiriesManagement';

const ThirdPartyEnquiries = () => {
  return <EnquiriesManagement serviceType="service" />;
};

export default ThirdPartyEnquiries;